<template>
  <div>
    <div v-if="!loading">
      <toolbar />
      <router-view> </router-view>
      <v-bottom-navigation app color="teal" grow>
        <v-btn to="/home">
          <span>Home</span>

          <v-icon>mdi-home</v-icon>
        </v-btn>

        <v-btn to="/group">
          <span>Groups</span>

          <v-icon>mdi-account-group</v-icon>
        </v-btn>

        <v-btn to="/report/home">
          <span>Report</span>

          <v-icon>mdi-chart-pie</v-icon>
        </v-btn>
      </v-bottom-navigation>
    </div>
    <div v-else>
      <v-dialog v-model="loading" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-container class="pa-5">
            <div class="mb-2">{{ $t("labels.pleaseStandBy") }}</div>
            <v-progress-linear indeterminate rounded height="6" color="white" class="mb-0">
            </v-progress-linear>
          </v-container>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import RegisterStoreModule from "@/mixins/RegisterStoreModule";
import layoutStore from "@/pages/Layout/store.js";
import LocationStore from "@/pages/Location/store.js";
// import integrationStore from '../Integration/store.js'
// import settingStore from '@/pages/Settings/store.js'
// import Navbar from '@/pages/Layout/components/NavigationPanel.vue'
import Toolbar from "@/pages/Layout/components/Toolbar.vue";
import backofficeService from "../../api/backoffice.js";
import { mapActions, mapGetters } from "vuex";
import locationService from '@/pages/Location/service.js'

export default {
  name: "layout",
  mixins: [RegisterStoreModule],
  async created() {
    this.registerStoreModule("layout", layoutStore);
    this.registerStoreModule("location", LocationStore);
    // await this.registerStoreModule('integration', integrationStore)
    // await this.registerStoreModule('settings', settingStore)
    // await this.registerStoreModule('tasks', tasksStore)
    // await this.checkToken()
    try {
      await this.$store.dispatch("global/initComboBox");
      await this.$store.dispatch("global/initUser");
      await this.$store.dispatch("global/initOrganization");
      await this.$store.dispatch("global/initState");
      this.loading = false;
    } catch (error) {
      console.log('error on login', error)
      this.loading = false
    }

    // await this.$store.dispatch('tasks/initTasks')
    this.getList()
    this.pollData();
  },
  components: {
    Toolbar
  },
  computed: {
    ...mapGetters("global", ["currentUser"]),
  },
  props: {
    source: String
  },
  beforeDestroy() {
    clearInterval(this.polling);
  },
  data() {
    return {
      loading: true,
      authenticated: true,
      polling: null
    };
  },
  watch: {
    authenticated(val) {
      if (!val) {
        this.$router.push("/login");
      }
    }
  },
  methods: {
    ...mapActions('location', ['setLocationList']),
    getList() {
      // console.log('xcdfd', localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}organizationID`))
      return locationService
        .getAll(localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}organizationID`))
        .then(response => {
          console.log('locationService response', response)
          let list = []
          response.data.map(location => {
            if(!location.ProductRelations[0].isCanceled) {
              list.push(location)
            }
          })
          console.log('list', list)
          this.setLocationList(list)
          // return response;
        });
    },
    async checkToken() {
      this.authenticated = await backofficeService.valid();
    },
    pollData() {
      this.polling = setInterval(() => {
        if (!localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}token`)) {
          this.authenticated = false;
        }
      }, 1000);
    }
  }
};
</script>
<style>
.desktop-view-container {
  height: calc(100vh - 58px);
  width: 100%;
}

.touch-view-container {
  height: calc(100vh - 58px);
  /* height: calc((calc(var(--vh, 1vh) * 100)) - 58px); */
  /* height: calc(var(--vh, 1vh) * 100); */
  width: 100%;
}

.full-width {
  width: 100%;
}

/* Allow v-select items to grow vertically and limit the horizontal grow*/
.v-menu__content>.v-select-list>.v-list>div>a {
  min-height: 48px !important;
  height: auto !important;
  max-width: 600px;
}

/* Limits the size of a td within a datatable */
.small-td {
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Limits the size of a td within a datatable */
.medium-td {
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Limits the size of a td within a datatable */
.large-td {
  max-width: 500px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
